import React, { useState } from "react";
import "../styles/UtahVerticals.css";
import "../styles/tailwind.css";
import Footer from "../components/Footer";
import LandingSection from "../components/HomePageLandingSection";
import ActionButton from "../utils/ActionButton";
import { useNavigate } from "react-router-dom";
import ScrambleText from "../utils/ScrambleText";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
const aerospace = "/img/utahdata/aerospace (1).webp";
const architecture = "/img/utahdata/cons3.webp";
const computer = "/img/utahdata/computer1.webp";
const engineering = "/img/utahdata/engineering1.webp";
const food = "/img/utahdata/food1.webp";
const human = "/img/utahdata/human.webp";
const manufacturing = "/img/utahdata/manufacturing1.webp";
const transportation = "/img/utahdata/transportation.webp";
const utah = "/img/utahdata/utah.webp";

const imageData = [
  {
    id: "manufacturing",
    name: "Vertical- Manufacturing",
    src: manufacturing,
    text: "Utah's manufacturing sector is diverse and growing, supporting industries from aerospace to food production with advanced technologies and skilled labor.",
    link: "/verticals/manufacturing",
  },
  {
    id: "architecture",
    name: "Vertical- Construction",
    src: architecture,
    text: "Utah's construction sector drives growth with innovative design and strong workforce.",
    link: "/verticals/construction",
  },
  // {
  //   id: "engineering",
  //   name: "Vertical- Professional, Scientific, and Technical Services",
  //   src: engineering,
  //   text: "Utah's professional, scientific, and technical services sector is a fast-growing innovation hub known as the Silicon Slopes.",
  //   link: "/verticals/professional-scientific-and-technical-services",
  // },
  {
    id: "computer",
    name: "Vertical- Information",
    src: computer,
    text: "Utah's information sector is thriving, driving innovation in software, cybersecurity, and digital services.",
    link: "/verticals/information",
  },
  {
    id: "Vertical- transportation",
    name: "Vertical- Transportation and Warehousing",
    src: transportation,
    text: "Utah's transportation and warehousing sector efficiently connects the region, driving economic growth through advanced infrastructure and strategic location.",
    link: "/verticals/transportation-and-warehousing",
  },
  {
    id: "aerospace",
    name: "Vertical- Aerospace and Defense",
    src: aerospace,
    text: "Utah is home to leading aerospace firms and military operations. This sector supports national defense and innovation in space technologies.",
    link: "/verticals/aerospace-and-defense",
  },
  // {
  //   id: "food",
  //   name: "Vertical- Food Industry",
  //   src: food,
  //   text: "Utah's food industry is a vital economic driver, blending agriculture, processing, and innovation to support jobs and statewide growth.",
  //   link: "/verticals/food-industry",
  // },
  // {
  //   id: "mining",
  //   name: "Vertical- Mining",
  //   src: "/img/verticals/Mining.webp",
  //   text: "Utah's mining industry plays a vital role in the state's economy, producing essential resources like copper, coal, gold, and salt.",
  //   link: "/verticals/mining",
  // },
  {
    id: "more",
    name: "& Many More ...",
    src: human,
    text: "Utah's human services sector supports the well-being of residents through vital programs in health, welfare, and community assistance. ",
    link: "/verticals",
  },
];

export default function HomePage() {
  const [selected, setSelected] = useState({});
  const navigate = useNavigate();

  function toggleSelection(id) {
    setSelected((prev) => {
      const newSelected = { ...prev };
      newSelected[id] = !prev[id];
      return newSelected;
    });
  }

  const handleNavigate = (link) => {
    console.log(link);
    navigate(link);
  };

  const handleClick = () => {
    navigate("/gallery");
  };

  return (
    <div>
      <LandingSection data="https://www.youtube.com/watch?v=CPGNlE_pXzQ" />

      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Beneath Utah's snowy peaks, data fuels discovery.</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              Explore the soul of Utah through rich insights, trends, and
              analytics. From majestic landscapes to dynamic industries,
              UTahData.org connects you with the stories and statistics shaping
              the state's future.
            </p>
            <ActionButton data="Know More About Us" link="/about-us" />
          </div>
        </div>
      </div>

      <section className="why-section">
        <div className="relative overflow-hidden whitespace-nowrap border-b">
          <div className="animate-marquee relative text-[14rem] md:text-[10rem] font-extrabold text-[#E6EDF7]">
            Utah At a Glance
          </div>
          <Link to={"/utah-at-a-glance"} className="no-underline">
            <h2 className="section-heading relative -mt-[10rem]">
              Utah At a Glance
            </h2>
          </Link>
        </div>

        <p className="mt-4 flex flex-wrap justify-center gap-2 text-base sm:text-lg md:text-xl">
          <span>
            <Link
              to="/utah-at-a-glance/utah-governor"
              className="no-underline text-black mx-2"
            >
              Governor's Corner
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/utah-at-a-glance/demographics"
              className="no-underline text-black mx-2"
            >
              Demographics
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/utah-at-a-glance/zipcodes"
              className="no-underline text-black mx-2"
            >
              Zip Codes
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/utah-at-a-glance/utah-airports"
              className="no-underline text-black mx-2"
            >
              Airports
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/utah-at-a-glance/air-quality-index"
              className="no-underline text-black mx-2"
            >
              Air Quality Index
            </Link>
          </span>
        </p>

        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153704.9445724846!2d-114.18689269814169!3d39.47407298438955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x874c6bc78f13f9cd%3A0xbddf4aa56cd7463f!2sUtah%2C%20USA!5e0!3m2!1sen!2sin!4v1748405065531!5m2!1sen!2sin"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Google map showing Utah"
        />
      </section>

      <div className="relative w-full h-[60vh]">
        <img
          src="/img/utahdata/star_1.webp"
          alt="star"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_rgba(72,113,247,0.6)_0%,_rgba(7,29,53,1)_60%,_rgba(0,0,0,1)_100%)] mix-blend-multiply"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
          <section>
            <p className="section-description text-white mt-0">
              Whether you are a policymaker, economist, student, entrepreneur,
              resident or planning one to visit Utah - UTahData.org connects you
              to the information that helps you to make informed decision.
            </p>
            <div className="flex flex-col lg:flex-row justify-center items-center mt-20 gap-24 stats-container">
              <div className="text-white text-xl sm:text-2xl lg:text-3xl font-extrabold w-full lg:w-[10rem] text-start">
                <a href="/verticals" className="no-underline text-white">
                  14+ Economic Verticals
                </a>
              </div>
              <div className="text-white text-xl sm:text-2xl lg:text-3xl font-extrabold w-full lg:w-[10rem] text-start">
                <a
                  href="/utah-at-a-glance/utah-counties"
                  className="no-underline text-white"
                >
                  County-Level Insights
                </a>
              </div>
              <div className="text-white text-xl sm:text-2xl lg:text-3xl font-extrabold w-full lg:w-[10rem] text-start">
                <a href="/utah-at-a-glance" className="no-underline text-white">
                  Interactive Utah At a Glance
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>

      <section className="why-section mt-0">
        <div className="relative overflow-hidden whitespace-nowrap border-b ">
          <div className="animate-marquee relative text-[14rem] md:text-[10rem] font-extrabold text-[#E6EDF7]">
            Utah Key Economic Verticals
          </div>
          <Link to={"/verticals"} className="no-underline">
            <h2 className="verticals-heading relative -mt-[10rem]">
              Utah Key Economic Verticals
            </h2>
          </Link>
        </div>

        <p className="mt-4 flex flex-wrap justify-center gap-2 text-base sm:text-lg md:text-xl">
          <span>
            <Link
              to="/verticals/manufacturing"
              className="no-underline text-black mx-2"
            >
              Manufacturing
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/verticals/construction"
              className="no-underline text-black mx-2"
            >
              Construction
            </Link>
          </span>
          {/* <span>|</span> */}
          {/* <span>
            <Link
              to="/verticals/professional-scientific-and-technical-services"
              className="no-underline text-black mx-2"
            >
              Professional, Scientific, and Technical Services
            </Link>
          </span> */}
          <span>|</span>
          <span>
            <Link
              to="/verticals/information"
              className="no-underline text-black mx-2"
            >
              Information
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/verticals/transportation-and-warehousing"
              className="no-underline text-black mx-2"
            >
              Transportation and Warehousing
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/verticals/aerospace-and-defense"
              className="no-underline text-black mx-2"
            >
              Aerospace and Defense
            </Link>
          </span>
          {/* <span>|</span>
          <span>
            <Link
              to="/verticals/food-industry"
              className="no-underline text-black mx-2"
            >
              Food Industry
            </Link>
          </span>
          <span>|</span>
          <span>
            <Link
              to="/verticals/mining"
              className="no-underline text-black mx-2"
            >
              Mining
            </Link>
          </span> */}
        </p>
      </section>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-1 p-1 rounded">
        {imageData.map((item, index) => (
          <div
            key={index}
            onClick={() => handleNavigate(item.link)}
            className="image-card"
          >
            <img
              src={item.src}
              alt={item.name || `Image ${index + 1}`}
              className="image-card-img"
            />

            {item.name && (
              <div className="image-card-overlay">
                <span>{item.name}</span>
              </div>
            )}
          </div>
        ))}
      </div>

      <div
        style={{
          height: "1px",
          width: "100%",
          background: "#014cb2",
          marginTop: "80px",
          marginBottom: "-30px",
        }}
      ></div>

      <div className="flex justify-center my-[6rem] px-4">
        <div className="image-container">
          <img src={utah} alt="Utah" className="image" />
          <div className="overlay">
            <div className="button-outer">
              <span className="corner top-left" />
              <span className="corner top-right" />
              <span className="corner bottom-left" />
              <span className="corner bottom-right" />
              <button
                className="action-button rounded-3xl"
                onClick={handleClick}
              >
                <span className="text">
                  <ScrambleText text="Utah Gallery" />
                </span>
                <ArrowUpRight className="icon" size={16} strokeWidth={2} />
              </button>
            </div>
            {/* <button onClick={handleClick} className="overlay-btn">
              Utah Gallery{" "}
              <ArrowUpRight className="icon" size={18} strokeWidth={3} />
            </button> */}
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
